import PropTypes from "prop-types";
import * as React from "react";
import { Card } from "../../themeV2";
import css from "./CustomizationCard.module.css";

export default function CustomizationCard({
  action,
  children,
  description,
  icon,
  price,
  selected = false,
  title,
}) {
  return (
    <li className={css.item}>
      <Card.Root variant={selected ? "filled" : "outlined"}>
        <Card.Header
          avatar={icon}
          title={title}
          subtitle={description}
          action={<span className={css.price}>{price}</span>}
        />
        {children && <Card.Content>{children}</Card.Content>}
        <Card.Actions>{action}</Card.Actions>
      </Card.Root>
    </li>
  );
}

CustomizationCard.propTypes = {
  action: PropTypes.node.isRequired,
  children: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.node,
  price: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  title: PropTypes.node.isRequired,
};
